import styled from "styled-components";
import {
  IMG_LOGO_HOME,
  SyncFilled,
} from "@assets";

export const Bar = styled.div`
  height: 70px;
  padding-inline: 16px;
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 1000;

@media screen and (max-width: 380px) {
  gap: 6px;
}

@media screen and (max-width: 369px) {
  padding-inline: 8px;
}

@media screen and (max-width: 330px) {
  gap: 4px;
}
`;

export const Logo = styled.img.attrs({
  alt: 'logo',
  src: IMG_LOGO_HOME,
})`
width: 100px;

@media screen and (max-width: 380px) {
  width: 70px;
}

@media screen and (max-width: 320px) {
  width: 55px;
}
`;

export const IconsWrapper = styled.div`
display: flex;
gap: 8px;
align-items: center;
justify-content: flex-end;

svg {
  cursor: pointer;
}

@media screen and (max-width: 380px) {
  gap: 6px;
}

@media screen and (max-width: 330px) {
  gap: 4px;

  svg {
    width: 20px;
  }
}
`;

export const Icon = styled.div`
display: flex;
gap: 4px;
align-items: center;
justify-content: center;
width: 32px;
height: 32px;

border-radius: 15px;
border: 2px solid #FFF;
background: linear-gradient(180deg, #00DE00 0%, #008500 97.5%, #008500 98.5%);
box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.10), 0px 7px 10px 0px rgba(255, 255, 255, 0.25) inset;
cursor: pointer;
`;

export const IconTextWrapper = styled(Icon)`
width: auto;
padding: 0 8px 0 6px;

border-radius: 15px;
border: 2px solid #FFF;
background: linear-gradient(180deg, #FFF970 0%, #E68A00 100%);
box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.10), 0px 7px 10px 0px rgba(255, 255, 255, 0.25) inset;

@media screen and (max-width: 380px) {
  padding: 0 6px 0 4px;
  gap: 2px;

  svg {
    width: 18px;
  }
}

@media screen and (max-width: 320px) {
  padding: 0 4px 0 2px;
  gap: 0px;

  svg {
    width: 14px;
  }
}
`;

export const IconText = styled.div`
color: #006400;
font-size: 12px;
font-style: normal;
font-weight: 700;
line-height: 1.5;

@media screen and (max-width: 380px) {
  font-size: 10px;
}
`;

export const TextWrapper = styled.div`
position: relative;
flex: 1;
display: flex;
gap: 2px;
height: 42px;
flex-direction: column;
align-items: flex-end;
justify-content: flex-end;
margin-right: 4px;
`;

export const Text = styled.div`
color: #fff;
font-size: 10px;
font-style: normal;
font-weight: 400;
line-height: 1.5;
`;

export const BoldText = styled(Text)`
font-weight: bold;
font-size: 14px;
min-height: 21px;

background: linear-gradient(180deg, #FFF970 0%, #E68A00 100%);
background-clip: text;
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;

@media screen and (max-width: 380px) {
font-size: 12px;
}

@media screen and (max-width: 320px) {
font-size: 11px;
}
`;

export const ReloadIcon = styled(SyncFilled)`
cursor: pointer;
width: 14px;
margin-bottom: -1px;
`;